<template>
  <modal name="cameraModal" :width="500" :height="700" :clickToClose="false"
    @before-open="beforeOpen"
    @opened="opened"
  >
    <div id="div_cameraModal" class="popup boundary">
      <div class="pop_tit">
        <span>사진을 촬영해 주세요.</span>
        <a href="javascript:void(0);" title="close" class="pop_close" @click="close">close</a>
      </div>
      <div class="pop_con_wrap">
        <div class="pop_con">
          <div class="pop_con_bg" style="padding: 20px;">
            <div
              v-if="!hasLimit || limitCnt > filesReders.length"
              style="display: flex; justify-content: center; margin-bottom: 10px; gap: 10px;">
              <button class="btn_type_01 delete" @click="activeCamera" >
                {{ imgCnt > 0 ? '추가 ' : ''  }}촬영
              </button>
              <button class="btn_type_01 delete" @click="openGallery" >
                {{ imgCnt > 0 ? '추가 ' : ''  }}선택
              </button>
              <button class="btn_type_01 delete" @click="confirm" >저장</button>
              <button class="btn_type_01" @click="close" >닫기</button>
            </div>
            <div style="display: flex; overflow: scroll;">
              <div
                v-for="(file, fileIndex) in filesReders"
                :key="`preShowImg_${fileIndex}`"
                class="img_view_cover"
              >
                <div class="img_view_header">
                  <div class="img_delete" @click="imgDelete(fileIndex)" />
                  <span style="background-color: black; padding: 5px;">
                    {{ `${fileIndex + 1} / ${filesReders.length}` }}
                  </span>
                </div>
                <img
                  v-if="filesReders[fileIndex]"
                  :id="`preShowImg_${fileIndex}`"
                  style="width: 100%; height: 100%;"
                  :src="filesReders[fileIndex].result"
                  :alt="file.name"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <input
      id="fileUploadEl"
      accept="image/*"
      type="file"
      style="visibility: hidden;"
      @change="handleOnChange"
    />
  </modal>
</template>

<script>
import concat from 'lodash/concat'

export default {
  name: 'CameraModal',
  components: {

  },
  data: () => ({
    filesReders: [],
    files: [],
    hasLimit: false,
    limitCnt: 0
  }),
  computed: {
    imgCnt () {
      return this.files.length
    }
  },
  created () {

  },
  mounted () {

  },
  watch: {

  },
  methods: {
    beforeOpen ({ params }) {
      this.filesReders = []
      this.files = []
      if (params && params.limitCnt) {
        this.hasLimit = true
        this.limitCnt = params.limitCnt
      }
    },
    opened () {
      let popLeft = (($(window).width() - $('#div_cameraModal').outerWidth()) / 2)
      let popTop = (($(window).height() - $('#div_cameraModal').outerHeight()) / 2)
      if (popLeft < 0) popLeft = 0
      if (popTop < 0) popTop = 0
      $('#popupMask').fadeIn()
      $('#div_cameraModal').css({'left': popLeft, 'top': popTop}).fadeIn().addClass('on')

      this.originZindex = window.getComputedStyle(document.getElementsByClassName('v--modal-overlay')[0]).zIndex
      document.getElementsByClassName('v--modal-overlay')[0].style.zIndex = 998

      this.activeCamera()
    },
    close () {
      this.closed()

      document.getElementsByClassName('v--modal-overlay')[0].style.zIndex = this.originZindex

      this.$modal.hide('cameraModal')
    },
    closed () {
      $('#pop_up').fadeOut().removeClass('on')
      $('#popupMask').fadeOut()
    },
    async confirm () {
      if (!this.files.length) {
        this.$Alert.alert('선택된 사진이 없습니다.')
        return
      }

      this.$emit('popupComplete', this.files)
      this.close()
    },
    activeCamera () {
      const inputEl = document.getElementById('fileUploadEl')
      inputEl.value = ''
      inputEl.files = null
      inputEl.removeAttribute('multiple')
      inputEl.setAttribute('capture', 'camera')
      inputEl.click()
    },
    openGallery () {
      const inputEl = document.getElementById('fileUploadEl')
      inputEl.value = null
      inputEl.removeAttribute('capture')
      inputEl.setAttribute('multiple', 'multiple')
      inputEl.click()
    },
    handleOnChange (e) {
      const {
        target: { files }
      } = e
      const fileTypes = ['jpg', 'png', 'jpeg', 'pdf']
      let fileTypeCheck = 0
      const fileOnload = (file) => {
        const reader = new FileReader()
        reader.onload = (e) => {
          const { target } = e
          this.filesReders = [target, ...this.filesReders]
        }
        reader.readAsDataURL(file)
      }
      if (files && files.length > 0) {
        fileTypes.forEach(fileType => {
          for (let idx in files) {
            const type = files[idx].type
            if (type && type.includes(fileType)) {
              fileTypeCheck++
            }
          }
        })
      } else {
        return
      }

      if (fileTypeCheck === files.length) {
        for (let i = 0; i < files.length; i++) {
          fileOnload(files[i])
        }
        this.files = [...this.files, ...Array.from(files)]
      } else {
        this.$Alert.alert('이미지 파일 jpg(jpeg), png  만 가능')
      }

      if (this.limitCnt > this.files.length) {
        this.$Alert.confirm('추가 촬영이 필요하신가요?')
          .then(res => {
            if (res) {
              const inputEl = document.getElementById('fileUploadEl')
              inputEl.setAttribute('capture', 'camera')
              this.activeCamera()
            }
          })
      }
    },
    imgDelete (trgtIdx) {
      this.filesReders = this.filesReders.filter((_file, idx) => {
        return idx !== trgtIdx
      })
      this.files = this.files.filter((_file, idx) => {
        return idx !== trgtIdx
      })
    }
  }
}
</script>

<style scoped>
.popup.boundary {
  width: 100%;
  height: 100%;
}
.img_view_cover {
  position: relative;
  border: 1px solid black;
  flex: 0 0 auto;
  width: 100%;
  margin-right: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/Camera.vue